import React, { useState } from "react";
import { Button, Image, Modal } from "react-bootstrap";
import moment from "moment";
import { ORDER_TYPE } from "../../../../enums/OrderEnums";

function ViewTransactionModal(props) {
  const [showDetails, setShowDetails] = useState(false);
  const onShowDetails = () => {
    setShowDetails(!showDetails);
    // setDetailType(data1);
  };
  return (
    <div>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => {
          onShowDetails();
        }}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/eye.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal
        show={showDetails}
        onHide={() => {
          onShowDetails(null);
        }}
        centered
        size={"xl"}
      >
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">
            {/* {props?.data?.orderId && "View Transaction Details"} */}
            View Transaction Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <div
            className="p-2"
            style={{ border: "1px solid #00000050", borderRadius: "5px" }}
          >
            <div>
              <div className="row f14-700">
                <div className="col-3">Source Request Type</div>
                <div className="col-3">User Name</div>
                <div className="col-2">Order Value</div>
                <div className="col-2">Tip</div>
                <div className="col-2">Donation</div>
              </div>
              <div className="row mt-2 f14-500 text-break">
                <div className="col-3">
                  {props?.data?.transaction_type === "SCAN_AND_PAY" &&
                  "Scan & Pay"
                    ? "Scan & Pay"
                    : ORDER_TYPE[props?.data?.orderId?.order_type] ||
                      props?.data?.event_request_id?.event_type ||
                      props?.scan_and_pay?.type ||
                      ""}
                  <br />
                  {props?.data?.transaction_type === "SCAN_AND_PAY" &&
                  "Scan & Pay"
                    ? ""
                    : props?.data?.orderId?.order_id ||
                      props?.data?.event_request_id?.event_request_id ||
                      ""}
                </div>
                <div className="col-3">
                  {props?.data?.user_id?.first_name}{" "}
                  {props?.data?.user_id?.last_name}
                </div>
                <div className="col-2">₹ {props?.data?.amount || 0}</div>
                <div className="col-2">
                  ₹ {props?.data?.orderId?.tip?.amount || 0}
                </div>
                <div className="col-2">
                  ₹ {props?.data?.orderId?.donation?.amount || 0}
                </div>
              </div>
            </div>
            <hr />
            <div>
              <div className="row">
                <div className="col-3">Description</div>
              </div>
              <div className="row">
                <div className="col-3">{props?.data?.message}</div>
              </div>
            </div>
          </div>
          <div className="f18-500 mt-2">Payment Details</div>
          <div
            className="p-2 mt-1"
            style={{ border: "1px solid #00000050", borderRadius: "5px" }}
          >
            <div>
              <div className="row f14-700">
                <div className="col-3">Transaction Id</div>
                <div className="col-3">Wallet Transaction Id</div>
                <div className="col-3">Payment Method</div>
                <div className="col-3"> Payment Status</div>
              </div>
              <div className="row mt-2 f14-500">
                <div className="col-3">
                  {props?.data?.transactionNumber !== undefined &&
                  props?.data?.transactionNumber !== null &&
                  props?.data?.transactionNumber !== ""
                    ? props?.data?.transactionNumber
                    : "N/A"}
                </div>
                <div className="col-3">
                  {props?.data?.payment_method !== undefined &&
                  props?.data?.payment_method !== null &&
                  props?.data?.payment_method !== ""
                    ? props?.data?.payment_method
                    : "N/A"}
                </div>
                <div className="col-3">
                  {props?.data?.payment_captured ? (
                    <div className="btn btn-success f11-500">Success</div>
                  ) : (
                    <div className="btn btn-warning f11-500">Pending</div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div>
              <div className="row">
                <div className="col-3">Payment Date/Time</div>
                <div className="col-3">Amount Paid</div>
              </div>
              <div className="row mt-2">
                <div className="col-3">
                  {moment(props?.data.createdAt).format("Do MMM, YYYY")}
                  <br /> {moment(props?.data.createdAt).format("hh:mm A")}
                </div>
                <div className="col-3">₹ {props?.data?.amount || 0}</div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ViewTransactionModal;
